import Litepicker from 'litepicker';
import TomSelect from 'tom-select';

const baseClass = 'get-booking-widget';

const GetBookingWidget = {
	init,
}

function init() {
	createInstances();
}

function createInstances() {
	const uninitialised = document.querySelectorAll(`.${baseClass}`);
	if (!uninitialised.length) {
		return;
	}

	uninitialised.forEach(widget => {
		const form = widget.querySelector('form');
		if (!form) {
			return;
		}

		form.setAttribute('novalidate', 'true'); // disable browser validation

		initDatesField(form);
		initGuestsField(form);
		initLocationField(form);
		setContextMeta(form);
		setReferrerMeta(form);
	})
}

/**
 * Sets up the date picker
 * @param form
 */
function initDatesField(form) {
	const input_start = form.querySelector('input[name="checkinFormatted"]');
	const input_end = form.querySelector('input[name="checkoutFormatted"]');
	const input_start_ymd = form.querySelector('input[name="checkin"]')
	const input_end_ymd = form.querySelector('input[name="checkout"]')
	const parentContainer = form.querySelector('.get-booking-widget__field-lockup--dates');

	//litepicker documentation: https://litepicker.com/docs/options
	if (input_start && input_end) {
		let lang = document.documentElement.getAttribute('lang');
		if ( !lang ) {
			lang = 'en-US';
		}

		const today = new Date();
		let tomorrow = today.setDate(today.getDate() + 1);

		const picker = new Litepicker({
			element: input_start,
			elementEnd: input_end,
			position: 'auto',
			parentEl: parentContainer,
			showTooltip: false,
			minDate: tomorrow,
			allowRepick: false,
			format: 'DD MMM',
			autoApply: true,
			autoRefresh: true,
			buttonText: {
				'nextMonth':'<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="#283755"/></svg>',
				'previousMonth':'<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z" fill="#283755"/></svg>',
			},
			setup: (picker) => {
				picker.on('selected', (date1, date2) => {
					const formattedDate = date1.format('YYYY-MM-DD'); // Format date as Ymd
					const formattedDateEnd = date2.format('YYYY-MM-DD'); // Format date as Ymd
					input_start_ymd.value = formattedDate; // Set the hidden input value
					input_end_ymd.value = formattedDateEnd;
				});
				picker.on('render', (ui) => {
					// add span to calendar elements for styling
					let day_elements =  document.querySelectorAll('.litepicker .day-item');

					day_elements.forEach((el) => {
						el.innerHTML = '<span>' + el.innerHTML + '</span>';
					});

					// change days of week to 1 letter abbreviation
					let weekday_titles =  document.querySelectorAll('.litepicker .month-item-weekdays-row > div');

					weekday_titles.forEach((el) => {
						el.innerHTML = el.innerHTML.slice(0,1);

						if ('miércoles' === el.getAttribute('title') 
							|| 'miercoles' === el.getAttribute('title') ) {
							el.innerHTML ='X'; // Spanish localisation
						}

					});
				});
			},
			lang: lang,
			numberOfColumns: 1,
			singleMode: false,
		});
	}
}

/**
 * Setups up the Guests Field with min/max and +/- buttons
 * @param form
 */
function initGuestsField(form) {
	const toggle = form.querySelector('#guests-toggle');

	if (toggle) {
		const modal_target = form.querySelector('#guests-modal');
		toggle.addEventListener('click', (e) => {
			modal_target.classList.toggle('active');
		});

		document.body.addEventListener('click', function(event) {
			if (!event.target.closest('#guests-modal') && !event.target.closest('#guests-toggle')) {
				modal_target.classList.remove('active');
			}
		});
	}

	const adultCounterWrapper = form.querySelector('.get-booking-widget__guest-adult');
	const childCounterWrapper = form.querySelector('.get-booking-widget__guest-lockup--child');


	if( adultCounterWrapper )
	{
		setupCounterButtons( adultCounterWrapper, form, true);
	}

	if( childCounterWrapper ) {
		setupCounterButtons( childCounterWrapper, form, false );
	}
}

/**
 * Setups up the Location Field
 * @param form
 */
function initLocationField(form) {

	const select = new TomSelect(
		form.querySelector('[data-id="tom-select"]'),
		{
			create: false,
			sortField: {
				field: 'text',
				direction: 'asc',
			},
		}
	);

	const location = form.querySelector('.get-booking-widget__location');
	if( location ) {
		location.addEventListener('change', (event) => {
			const selectedItem = event.target.options[event.target.selectedIndex];
			const type = selectedItem.getAttribute('data-type');
			location.setAttribute('name', type);
		});

		// Set the default location
		const locationSelectedIndex = location.selectedIndex;
		if ( locationSelectedIndex )
		{
			let locationSelected = location.options[locationSelectedIndex];
			if (locationSelected) {
				const type = locationSelected.getAttribute('data-type');
				location.setAttribute('name', type);
			}
		}
	}	
}

/**
 * Updates teh total label for guests, e.g. 1 Guest to 2 Guests
 * @param form
 */
function updateTotalGuestCounter(form) {
	const adults = form.querySelector('.get-booking-widget__guest-adult input[type="number"]');
	const children = form.querySelector('.get-booking-widget__guest-lockup--child input[type="number"]');
	const totalObj = form.querySelector('.total-guests');
	
	const guestsLabel = form.querySelector('#guest-label');
	const adultsLabel = form.querySelector('#adult-label');
	const childrenLabel = form.querySelector('#child-label');

	let total = 0;
	if( adults ) {
		total += Number(adults.value);
	}
	if( children )
	{
		total += Number(children.value);
	}

	if ( total <= 0 )
	{
		// Fallback for incorrect input
		total = 1;
	}

	totalObj.innerHTML = total;

	if( guestsLabel )
	{
		const singleLabel = guestsLabel.getAttribute('data-singular');
		const pluralLabel = guestsLabel.getAttribute('data-plural');

		if( Number(total) > 1 )
		{
			guestsLabel.innerHTML = pluralLabel;
		}
		else
		{
			guestsLabel.innerHTML = singleLabel;
		}
	}

	if( adultsLabel )
	{
		const singleLabel = adultsLabel.getAttribute('data-singular');
		const pluralLabel = adultsLabel.getAttribute('data-plural');

		if( Number(adults.value) > 1 )
		{
			adultsLabel.innerHTML = pluralLabel;
		}
		else
		{
			adultsLabel.innerHTML = singleLabel;
		}
	}

	if( childrenLabel )
	{
		const singleLabel = childrenLabel.getAttribute('data-singular');
		const pluralLabel = childrenLabel.getAttribute('data-plural');

		if( Number(children.value) != 1 )
		{
			childrenLabel.innerHTML = pluralLabel;
		}
		else
		{
			childrenLabel.innerHTML = singleLabel;
		}
	}
}

/**
 * Sets the add/minus buttons for the number inputs
 * @param wrapper
 * @param form
 */
function setupCounterButtons(wrapper, form, restrictMinimum) {
	const input = wrapper.querySelector('input[type="number"]');
	const add = wrapper.querySelector('button.increment');
	const remove = wrapper.querySelector('button.decrement');
	
	let minimumValue = 0;
	if (restrictMinimum === true) {
		minimumValue = 1;
	}

	add.addEventListener('click', () => {
		let number = Number(input.value);

		if( number <= 0 )
		{
			number = 1;
		}
		else
		{
			number++;
		}

		if( number > 0 )
		{
			remove.removeAttribute('disabled');
		}
		else
		{
			remove.setAttribute('disabled', 'disabled');
		}

		input.value = number;
		updateTotalGuestCounter(form);
	});

	remove.addEventListener('click', () => {
		let number = Number(input.value);
		number--;
		if( number <= 0 )
		{
			number = 0;
		}

		if( number > minimumValue )
		{
			remove.removeAttribute('disabled');
		}
		else
		{
			remove.setAttribute('disabled', 'disabled');
		}

		input.value = number;
		updateTotalGuestCounter(form);
	});

}

function setContextMeta(form) {
	const input = form.querySelector('input[name="context"]');
	if (!input) {
		return;
	}

	input.value = window.location.toString();
}

function setReferrerMeta(form) {
	const input = form.querySelector('input[name="referrer"]');
	if (!input) {
		return;
	}

	input.value = document.referrer;
}

export default GetBookingWidget;



// WEBPACK FOOTER //
// ./scripts/modules/get-booking-widget.js